(function() {
  'use strict';

  var dataLayer = window.dataLayer = window.dataLayer || [];

  // Helper: coerce variant_id to string for consistent GTM variable types
  function toStr(val) {
    return val != null ? String(val) : '';
  }

  // Helper: get current variant info from the product form
  function getVariantInfo() {
    var form = document.querySelector('[data-product-form]');
    if (!form) return {};

    var select = form.querySelector('select[name="id"]');
    var variantId = select ? select.value : null;
    var variantTitle = select ? select.options[select.selectedIndex].textContent.trim() : '';

    // Get product data from JSON script tag
    var productJsonEl = document.querySelector('script[id^="ProductJson-"]');
    var product = null;
    var variant = null;

    if (productJsonEl) {
      try {
        product = JSON.parse(productJsonEl.textContent);
        if (variantId && product.variants) {
          variant = product.variants.find(function(v) { return v.id === parseInt(variantId); });
        }
      } catch (e) {}
    }

    return {
      product_name: product ? product.title : '',
      product_id: product ? product.id : '',
      variant_id: variantId,
      variant_title: variant ? variant.title : variantTitle,
      variant_price: variant ? (variant.price / 100).toFixed(2) : '',
      variant_sku: variant ? variant.sku : '',
      currency: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'INR'
    };
  }

  // 1. pdp_add_to_cart — listen to theme's custom "cart:item-added" event
  document.addEventListener('cart:item-added', function(evt) {
    var item = evt.detail ? evt.detail.product : null;
    var payload = {
      event: 'pdp_add_to_cart'
    };
    if (item) {
      payload.product_name = item.product_title || item.title || '';
      payload.product_id = item.product_id || '';
      payload.variant_id = toStr(item.variant_id || item.id);
      payload.variant_title = item.variant_title || '';
      payload.variant_price = item.final_line_price ? (item.final_line_price / 100).toFixed(2) : '';
      payload.variant_sku = item.sku || '';
      payload.quantity = item.quantity || 1;
      payload.currency = window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'INR';
    } else {
      // Fallback to form data
      var info = getVariantInfo();
      Object.assign(payload, info);
      payload.quantity = 1;
    }
    dataLayer.push(payload);
  });

  // 2. pdp_buy_now — intercept click on Shopify's dynamic checkout button
  //    The button lives inside a shadow DOM chain:
  //      .shopify-payment-button > <shopify-accelerated-checkout> (shadow) > <shopify-buy-it-now-button> (shadow) > button
  //    The shadow DOM stops the click from bubbling out in the bubble phase.
  //    Using CAPTURE phase ensures our listener fires first (document → down to target),
  //    before the shadow DOM internals can call stopPropagation().
  //    At the document level, event.target is retargeted to the outermost shadow host
  //    (<shopify-accelerated-checkout>), which is inside .shopify-payment-button.
  document.addEventListener('click', function(evt) {
    var target = evt.target;
    if (!target.closest('.shopify-payment-button') &&
        target.tagName !== 'SHOPIFY-ACCELERATED-CHECKOUT' &&
        target.tagName !== 'SHOPIFY-BUY-IT-NOW-BUTTON') return;

    var info = getVariantInfo();
    dataLayer.push(Object.assign({ event: 'pdp_buy_now', quantity: 1 }, info));
  }, true);

  // 3. pdp_made_to_order — listen to custom event dispatched by made-to-order-dialog.js
  //    Click-based delegation won't work because the dialog handler calls stopPropagation().
  //    Debounce: overlapping click handlers in made-to-order-dialog.js can dispatch
  //    mto:dialog-opened twice for the same click (main + drawer buttons share a
  //    delegated listener). We suppress duplicate pushes within 300ms.
  var lastMtoPush = 0;
  document.addEventListener('mto:dialog-opened', function(evt) {
    var now = Date.now();
    if (now - lastMtoPush < 300) return;
    lastMtoPush = now;

    var details = evt.detail || {};
    var payload = {
      event: 'pdp_made_to_order',
      product_name: details.productName || '',
      variant_id: toStr(details.variantId),
      variant_title: details.variantTitle || '',
      variant_price: details.variantPrice ? (details.variantPrice / 100).toFixed(2) : '',
      currency: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'INR'
    };

    dataLayer.push(payload);
  });
})();
